/**
 * R.E.ASSIST の行き先（パスとラベル）。サイドバー、マイページ、/reassist、/reassist/archive が参照する正本。
 * アイコンは各画面の部品が持つ（このファイルは React に依存させない）。
 */

/** 役所資料の依頼画面。 */
export const REASSIST_REQUEST_PATH = "/realestatedocumentfetch";
/** 依頼状況・過去の依頼・請求の画面。 */
export const REASSIST_STATUS_PATH = "/reassist";
/** リユース資料（黒塗り）を探して購入する画面。 */
export const REASSIST_ARCHIVE_PATH = "/reassist/archive";
/** 地図で探すときに開く地図画面（役所資料のレイヤーをオンにして開く）。 */
export const REASSIST_MAP_PATH = "/map?municipalDocuments=true";

export const REASSIST_LABELS = {
  /** サービス名。aria-label と Tooltip に使う。 */
  service: "R.E.ASSIST",
  request: "役所資料を依頼する",
  status: "依頼状況・請求",
  archive: "役所資料を探す",
  map: "地図で見る",
  /** サイドバーのロゴに付けるツールチップ。 */
  sideMenuTooltip: "役所資料の取得を代行します",
} as const;

/** /reassist と /reassist/archive の本文の列の最大幅（左寄せ）。 */
export const REASSIST_CONTENT_MAX_WIDTH = 960;
